import { useContext } from "react";
import { QuestionnaireContext } from "./context";

const useQuestionnaireContext = () => useContext(QuestionnaireContext)

export { useQuestionnaireContext }